import UpdateStoreSettings from './UpdateStoreSettings'

export { UpdateStoreSettings }
